import { Invoice, KmstackABParty, TimeEntry, TimeSheetGroup } from "@/types";


export enum KMStackEvent {

  // UI events
  DISABLE_ENABLE_MAIN_VIEW = "ui:disableMainView",

  USER_LOGIN = "user:login",
  USER_LOGOUT = "user:logout",
  INVOICE_CREATED = "invoice:created",
  INVOICE_UPDATED = "invoice:updated",
  INVOICE_DELETED = "invoice:deleted",
  TRANSACTION_ADDED = "transaction:added",
  CHAT_MESSAGE = "chat:message",

  // inventory


  // clients - suppliers
  ADD_PARTY_CURRENT_FORM_VALUES = "addParty:currentFormValues",


  // time tracking events
  TIME_ON_SAVE_ENTRY = "time:saveEntry",
  TIME_ON_DELETE_ENTRY = "time:deleteEntry",
  // time sheet events
  TIME_SHEET_ON_ADD_MANUALLY = "timeSheet:onAddManualEntry",
  TIME_SHEET_ON_EDIT_ENTRY = "timeSheet:onEditEntry",
  TIME_SHEET_ON_DELETE_ENTRY = "timeSheet:onDeleteEntry",
  TIME_SHEET_ON_OPEN_REPORT = "timeSheet:onOpenReport",
  TIME_SHEET_ON_ADD_MONTHLY = "timeSheet:onAddMonthly",
  TIME_SHEET_ON_OPEN_FULL_REPORT = "timeSheet:onOpenFullReport",

  // EMPLOYEE
  EMPLOYEE_ON_ADD_EMPLOYEE = 'employee:onAddEmployee',

  // INVOICE UI
  INVOICE_ON_GENERATE = 'invoice:onGenerate',
  INVOICE_ON_EDIT = 'invoice:onEdit',
  INVOICE_ON_VIEW = 'invoice:onView',

  // Common
  NOTIFICATION = 'common:notification',
}

export type KMStackEvents = {
  [KMStackEvent.USER_LOGIN]: { userId: string; email: string };
  [KMStackEvent.USER_LOGOUT]: { userId: string };
  [KMStackEvent.INVOICE_CREATED]: { id: string; amount: number; clientId: string };
  [KMStackEvent.INVOICE_UPDATED]: { id: string; changes: Record<string, any> };
  [KMStackEvent.INVOICE_DELETED]: { id: string };
  [KMStackEvent.TRANSACTION_ADDED]: { id: string; amount: number; category: string };
  [KMStackEvent.CHAT_MESSAGE]: { from: string; text: string };
  [KMStackEvent.TIME_ON_SAVE_ENTRY]: TimeEntry;
  [KMStackEvent.TIME_ON_DELETE_ENTRY]: TimeEntry;
  [KMStackEvent.TIME_SHEET_ON_EDIT_ENTRY]: TimeEntry;
  [KMStackEvent.TIME_SHEET_ON_DELETE_ENTRY]: TimeEntry;
  [KMStackEvent.TIME_SHEET_ON_OPEN_REPORT]: TimeEntry;
  [KMStackEvent.TIME_SHEET_ON_ADD_MANUALLY]: any;
  [KMStackEvent.TIME_SHEET_ON_ADD_MONTHLY]: any;
  [KMStackEvent.TIME_SHEET_ON_OPEN_FULL_REPORT]: TimeSheetGroup;
  [KMStackEvent.EMPLOYEE_ON_ADD_EMPLOYEE]: boolean;
  [KMStackEvent.ADD_PARTY_CURRENT_FORM_VALUES]: KmstackABParty
  [KMStackEvent.DISABLE_ENABLE_MAIN_VIEW]: { value: boolean, msg?: string };
  [KMStackEvent.NOTIFICATION]: { title: string; message: string; type: 'success' | 'error' | 'warning' | 'info' };
  [KMStackEvent.INVOICE_ON_GENERATE]: any;
  [KMStackEvent.INVOICE_ON_EDIT]: Invoice;
  [KMStackEvent.INVOICE_ON_VIEW]: Invoice;
};
